(function () {
  if (window.__megaMenuHoverSwapBound) return;
  window.__megaMenuHoverSwapBound = true;

  function findColumnImg(a) {
    const col = a.closest(".mega-menu__column");
    if (!col) return null;
    return col.querySelector("img.js-mega-swap-img");
  }

  function swapTo(img, url) {
    if (!img || !url) return;

    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.currentSrc || img.src;
      img.dataset.originalSrcset = img.getAttribute("srcset") || "";
      img.dataset.originalSizes = img.getAttribute("sizes") || "";
    }

    img.src = url;
    img.srcset = url;
    img.removeAttribute("sizes");
  }

  function restore(img) {
    if (!img || !img.dataset.originalSrc) return;

    img.src = img.dataset.originalSrc;

    if (img.dataset.originalSrcset)
      img.setAttribute("srcset", img.dataset.originalSrcset);
    else img.removeAttribute("srcset");

    if (img.dataset.originalSizes)
      img.setAttribute("sizes", img.dataset.originalSizes);
  }

  document.addEventListener("mouseover", (e) => {
    const a = e.target.closest(".mega-menu__link--child[data-hover-img]");
    if (!a || a.contains(e.relatedTarget)) return;

    const img = findColumnImg(a);
    if (!img) return;

    swapTo(img, a.dataset.hoverImg);
  });

  document.addEventListener("mouseout", (e) => {
    const a = e.target.closest(".mega-menu__link--child[data-hover-img]");
    if (!a || a.contains(e.relatedTarget)) return;

    const img = findColumnImg(a);
    if (!img) return;

    restore(img);
  });
})();
